export default "__VITE_ASSET__VqbGfIpf__"